export default "__VITE_ASSET__CMMm2fKc__"